export const renderNumber = (
  num: number | undefined,
  str: string
): number | string => {
  if (typeof num === 'undefined' || Number.isNaN(num)) return str;
  return num;
};

export const matchString = (text?: string, query?: string): boolean => {
  if (!query) return true;
  if (!text) return false;
  return text.toLowerCase().includes(query.toLowerCase());
};
export const arrayIncludes = (list: any[], query?: any): boolean => {
  return list.some((item) => item === query);
};
